import styled from 'styled-components';

export const SVG = styled.svg`
  display: inline-block;
  fill: currentColor;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  width: 1em;

  ${({ $styles }) => $styles}
`;
